import React from "react";
import PropTypes from "prop-types";

import { Stepper } from "@progress/kendo-react-layout";

import { defaultTemplate } from "core/hoc";

function StepperTemplate(props) {
    const { store, className } = props;
    const { currentStep, onChange, items } = store;

    return (
        <Stepper
            value={currentStep}
            onChange={onChange}
            items={items}
            className={className}
        />
    );
}

StepperTemplate.propTypes = {
    store: PropTypes.object.isRequired,
    assignProps: PropTypes.any,
    className: PropTypes.string,
    t: PropTypes.func,
};

export default defaultTemplate(StepperTemplate);